import { useRef } from "react";
import emailjs from "@emailjs/browser";
import toast, { Toaster } from "react-hot-toast";
import { FiMail } from "react-icons/fi";

export default function Contact() {
  const form = useRef();
  const serviceId = "service_ypd9nuu";
  const templateId = "template_o8myqsz";
  const publicKey = "E25Aj06ednLjej19k";
  const sendEmail = (e) => {
    e.preventDefault();

    emailjs.sendForm(serviceId, templateId, form.current, publicKey).then(
      (result) => {
        toast.success("Message Successfully Sent!");
      },
      (error) => {
        toast.error("An Error Occurred! Please try again.");
      },
    );
  };
  return (
    <>
      <section id="contact">
        <Toaster position="top-center" reverseOrder={false} />
        <div className="container px-6 md:px-20 lg:px-24 mx-auto pt-12 md:p-24">
          <div className="lg:flex">
            <div className="lg:w-1/2">
              <h1 className="text-xl sm:text-2xl lg:text-3xl font-bold text-gray-800 pb-8">
                Contact Us
              </h1>

              <h1 className="mt-2 text-gray-600 font-medium  md:text-xl">
                Please take a moment to fill out the form.
              </h1>
              <a
                href="mailto:duleosclub@gmail.com"
                className="mt-4 inline-flex items-center gap-2 text-gray-700 font-medium hover:text-[#1D4C60] hover:underline transition-colors"
              >
                <FiMail className="text-lg" />
                duleosclub@gmail.com
              </a>
              <p className="mt-2 pr-0 lg:pr-24 text-md text-gray-600 capitalize">
                Every activity we undertake is rooted in our core belief:
                <strong> Leadership. Experience. Opportunity.</strong>
                <br />
                <br />
                We’re not just building a club — we’re building
                <strong> leaders of tomorrow </strong>who are socially
                conscious, action-oriented, and ready to create change in the
                society at a large.
              </p>
            </div>

            <div className="mt-8 lg:w-1/2 lg:mt-0">
              <form
                className="w-full lg:max-w-xl"
                ref={form}
                onSubmit={sendEmail}
              >
                <div className="relative flex items-center">
                  <input
                    type="text"
                    name="user_fullname"
                    className="block w-full py-3 text-gray-700 bg-white border border-slate-300 rounded-lg px-4 focus:border-slate-400  focus:ring-slate-300 focus:outline-none focus:ring focus:ring-opacity-40"
                    placeholder="Full Name"
                  />
                </div>

                <div className="relative flex items-center mt-4">
                  <input
                    type="email"
                    name="user_email"
                    className="block w-full py-3 text-gray-700 bg-white border border-slate-300 rounded-lg px-4 focus:border-slate-400 focus:ring-slate-300  focus:outline-none focus:ring focus:ring-opacity-40"
                    placeholder="Email Address"
                  />
                </div>
                <div className="relative flex items-center mt-4">
                  <textarea
                    type="text"
                    name="message"
                    className="block w-full py-3 text-gray-700 bg-white border border-slate-300 rounded-lg px-4 focus:border-slate-400 focus:ring-slate-300  focus:outline-none focus:ring focus:ring-opacity-40"
                    rows="4"
                    cols="50"
                    placeholder="Your Message"
                  />
                </div>
                <div className="mt-8 md:flex md:items-center">
                  <input
                    type="submit"
                    value="Submit"
                    className="w-full px-6 py-4 text-md font-medium tracking-wide text-white capitalize transition-colors duration-300 transform bg-[#1D4C60] rounded-lg md:w-1/2 hover:bg-[#296e8b] focus:outline-none focus:ring focus:ring-blue-300 focus:ring-opacity-50"
                  />
                </div>
              </form>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
